import React from 'react';
import {Button, Flex, Modal} from "antd";
import CustomButton from "../../../../../components/UI/CustomButton/CustomButton";
import './verification-request-to-owner-modal.scss'
import {useNavigate} from "react-router";

interface VerificationRequestModalProps {
  visible: boolean;
  onClose: () => void;
  companyEmail: string;
}

const VerificationRequestToOwnerModal = ({ visible, onClose, companyEmail }: VerificationRequestModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      closable={false}
      className="verification-modal"
    >
      <Flex vertical gap={'13px'} className="verification-modal__content">
        <h2 className="verification-modal__title">Verification request sent</h2>
        <p className="verification-modal__description">
          We've sent a  request to your email {companyEmail} Please complete the verification to confirm your company ownership.
        </p>
        <Flex className="verification-modal__button">
          <CustomButton text={'Ok'} disable={false} onClick={() => navigate('../')}/>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default VerificationRequestToOwnerModal;